/**
 * Whether an offboarding accounts update wrote every account it was asked to
 * (PLO-6545). The endpoint answers success with the accounts it actually wrote
 * and leaves out any it would not touch (cancelled, no longer this member's, or
 * finished for that change), so success alone does not mean the row moved.
 */
export const wroteAccounts = (
  written: { id: string }[] | undefined,
  accountIds: string[],
): boolean =>
  accountIds.every((id) => (written ?? []).some((account) => account.id === id));

export const ACCOUNT_NOT_UPDATED = {
  status: "error",
  title: "This account was not updated",
  description:
    "It may have been cancelled or handed to someone else. Refresh to see where it stands.",
} as const;
